import { Dialog, styled } from "@mui/material";

const StyledDialog = styled(Dialog)(({ theme }) => {
  return {
    "& .MuiDialog-paper": {
      borderRadius: theme.shape.borderRadius + "px",
    },
    "& .MuiDialogTitle-root": {
      ...theme.typography.h4,
      textAlign: "center",
    },
    "& .MuiDialogContent-root": {
      padding: theme.spacing(4),
    },
    "& .MuiDialogActions-root": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      gap: theme.spacing(2),
    },
  };
});

export default StyledDialog;
